module.exports = __webpack_public_path__ + "static/media/5.df611012.JPG";